import log from "loglevel";
export function onScreenUpdate(callback) {
    $(window).resize(() => {
        callback(calculateScreen());
    });
}
export const MAXIMUM_WIDTH = 1440 / 2;
export const MAXIMUM_HEIGHT = 2776 / 2;
function getWindowWidth() {
    return document.body.clientWidth;
}
function getWindowHeight() {
    return window.innerHeight;
}
export function updateScreen(selector) {
    const { screen, viewport } = calculateScreen();
    console.dir({
        screen,
        viewport,
    });
    const scene = $(selector);
    scene.css("width", screen.width);
    scene.css("height", screen.height);
    scene.attr("width", viewport.width);
    scene.attr("height", viewport.height);
}
export const updateHTMLElement = {
    /**
     * 기본 방식. 항상 보이는 영역이 있고 준비된 영역이 있고,
     * 레터박스 영역이 있다.
     */
    base({ selectorParent, selectorChild, }) {
        const { screen, viewport } = calculateScreen();
        const scene = $(selectorParent);
        scene.css("width", screen.width);
        scene.css("height", screen.height);
        const child = $(selectorChild);
        child.css("transform", `scale(${screen.width / viewport.width}, ${screen.height / viewport.height})`);
        child.css("width", MAXIMUM_WIDTH);
        child.css("height", MAXIMUM_HEIGHT);
        child.css("position", "absolute");
        const top = -(MAXIMUM_HEIGHT - viewport.height) / 2 -
            (viewport.height - screen.height) / 2;
        child.css("top", top);
        const left = -(MAXIMUM_WIDTH - viewport.width) / 2 -
            (viewport.width - screen.width) / 2;
        child.css("left", left);
    },
    /**
     * 높이가 항상 스크린 높이와 같다.
     */
    fullHeight({ selectorParent, selectorChild, }) {
        const windowSize = {
            width: getWindowWidth(),
            height: getWindowHeight(),
        };
        const { screen, viewport } = calculateScreen();
        log.debug("sizes", { screen, viewport, windowSize });
        screen.height = Math.max(windowSize.height, screen.height);
        viewport.height = (viewport.width * screen.height) / screen.width;
        const scene = $(selectorParent);
        scene.css("width", screen.width);
        scene.css("height", screen.height);
        const child = $(selectorChild);
        child.css("transform", `scale(${screen.width / viewport.width})`);
        child.css("width", MAXIMUM_WIDTH);
        const insideHeight = (screen.height * viewport.width) / screen.width;
        child.css("height", insideHeight);
        child.css("position", "absolute");
        const top = -(insideHeight - viewport.height) / 2 -
            (viewport.height - screen.height) / 2;
        child.css("top", top);
        const left = -(MAXIMUM_WIDTH - viewport.width) / 2 -
            (viewport.width - screen.width) / 2;
        child.css("left", left);
    },
    /**
     * 기본 계산에서 높이가 남으면 위아래에 붙는다.
     */
    fullHeightIfTall({ selectorParent, selectorChild, }) {
        const windowSize = {
            width: getWindowWidth(),
            height: getWindowHeight(),
        };
        const { screen, viewport } = calculateScreen();
        log.debug("sizes", { screen, viewport, windowSize });
        screen.height = Math.max(windowSize.height, screen.height);
        viewport.height = (viewport.width * screen.height) / screen.width;
        const scene = $(selectorParent);
        scene.css("width", screen.width);
        scene.css("height", screen.height);
        const child = $(selectorChild);
        child.css("transform", `scale(${screen.width / viewport.width})`);
        child.css("width", MAXIMUM_WIDTH);
        let insideHeight;
        insideHeight = (screen.height * viewport.width) / screen.width;
        insideHeight = Math.max(insideHeight, MAXIMUM_HEIGHT);
        child.css("height", insideHeight);
        child.css("position", "absolute");
        const top = -(insideHeight - viewport.height) / 2 -
            (viewport.height - screen.height) / 2;
        child.css("top", top);
        const left = -(MAXIMUM_WIDTH - viewport.width) / 2 -
            (viewport.width - screen.width) / 2;
        child.css("left", left);
    },
};
function isSameRatio(ratioA, ratioB) {
    return ratioA.width * ratioB.height === ratioA.height * ratioB.width;
}
function isWidthBigger(ratioA, ratioB) {
    return ratioA.width * ratioB.height < ratioA.height * ratioB.width;
}
function isHeightBigger(ratioA, ratioB) {
    return ratioA.width * ratioB.height > ratioA.height * ratioB.width;
}
function isWidthBiggerOrEqual(ratioA, ratioB) {
    return ratioA.width * ratioB.height <= ratioA.height * ratioB.width;
}
function isHeightBiggerOrEqual(ratioA, ratioB) {
    return ratioA.width * ratioB.height >= ratioA.height * ratioB.width;
}
function isWidthBetween(ratioA, ratioB, ratioC) {
    return isWidthBigger(ratioA, ratioB) && isWidthBigger(ratioB, ratioC);
}
function isHeightBetween(ratioA, ratioB, ratioC) {
    return isHeightBigger(ratioA, ratioB) && isHeightBigger(ratioB, ratioC);
}
/**
 * Here is the function calculateScreen
 * screen: 화면에 실제로 보일 사이즈
 * viewport: 720 1388 기준 가운데 정렬로 했을 때 보여줄 범위
 */
export function calculateScreen() {
    const maximumWidth = 1440 / 2;
    const maximumHeight = 2776 / 2;
    const minimumWidth = 1280 / 2;
    const minimumHeight = 1920 / 2;
    const defaultRatio = {
        width: minimumWidth,
        height: minimumHeight,
    };
    const maximumWidthRatio = {
        width: maximumWidth,
        height: minimumHeight,
    };
    const maximumHeightRatio = {
        width: minimumWidth,
        height: maximumHeight,
    };
    const currentWidth = getWindowWidth();
    const currentHeight = getWindowHeight();
    const currentRatio = {
        width: currentWidth,
        height: currentHeight,
    };
    if (isSameRatio(defaultRatio, currentRatio)) {
        return {
            screen: {
                width: currentWidth,
                height: currentHeight,
            },
            viewport: {
                width: minimumWidth,
                height: minimumHeight,
            },
        };
        // additional width
    }
    else if (isWidthBetween(defaultRatio, currentRatio, maximumWidthRatio)) {
        // minimumWidth <= viewportWidth <= maximumWidth
        // viewportWidth == (current width / current height) * minimum height
        const viewPortWidth = (currentWidth * minimumHeight) / currentHeight;
        console.assert(viewPortWidth <= maximumWidth, "viewPortWidth <= maximumWidth");
        return {
            screen: {
                width: currentWidth,
                height: currentHeight,
            },
            viewport: {
                width: viewPortWidth,
                height: minimumHeight,
            },
        };
        // additional width
    }
    else if (isWidthBiggerOrEqual(maximumWidthRatio, currentRatio)) {
        const screenWidth = (maximumWidth * currentHeight) / minimumHeight;
        return {
            screen: {
                width: screenWidth,
                height: currentHeight,
            },
            viewport: {
                width: maximumWidth,
                height: minimumHeight,
            },
        };
        // additional height
    }
    else if (isHeightBetween(defaultRatio, currentRatio, maximumHeightRatio)) {
        const viewPortHeight = (currentHeight * minimumWidth) / currentWidth;
        return {
            screen: {
                width: currentWidth,
                height: currentHeight,
            },
            viewport: {
                width: minimumWidth,
                height: viewPortHeight,
            },
        };
    }
    else if (isHeightBiggerOrEqual(maximumHeightRatio, currentRatio)) {
        const screenHeight = (maximumHeight * currentWidth) / minimumWidth;
        return {
            screen: {
                width: currentWidth,
                height: screenHeight,
            },
            viewport: {
                width: minimumWidth,
                height: maximumHeight,
            },
        };
    }
    else {
        console.error("Unrechable");
        return {
            screen: {
                width: currentWidth,
                height: currentHeight,
            },
            viewport: {
                width: minimumWidth,
                height: minimumHeight,
            },
        };
    }
}
//# sourceMappingURL=screen.js.map